import { FEATURES } from "@/utils/navigation";

export const FIRST_STEP_IDX = 0;
export const TOTAL_STEPS_IDX = 3;

export const STEP_POSITIONS = {
  [FEATURES.telematics]: 0,
  [FEATURES.compliance]: 310,
  [FEATURES.alerts]: 610,
  [FEATURES.reports]: 910,
};
